import React, { Fragment } from "react"
import { Helmet } from "react-helmet"
import { Link } from "react-router-dom"




//componets
import ThemeMenuThree from "../../../components/header/ThemeMenuThree"
import PageTitle from "../../../components/page-title/PageTitle"
import BlogStyleTwo from "../../../components/blog/BlogStyleTwo"
import NewsletterTwo from "../../../components/call-to-action/NewsletterTwo"
import FooterThree from "../../../components/footer/FooterThree"




const BlogGrid = () => {

    return (
        <Fragment>
            <div className="main-page-wrapper">
                {/* Helmet start */}
                <Helmet>
                    <title>Blog de Tecnología e Innovación</title>
                    <meta name="description" content="Artículos sobre tecnología, ciberseguridad, desarrollo web e innovación digital en Ecuador. Mantente actualizado con el blog de CuySoft." />
                    <meta name="keywords" content="blog tecnología Ecuador, artículos ciberseguridad, noticias desarrollo web, innovación digital, CuySoft blog" />
                    <link rel="canonical" href="https://www.cuysoft.com/blog-grid" />
                    <meta property="og:title" content="Blog de Tecnología e Innovación – CuySoft" />
                    <meta property="og:description" content="Artículos sobre tecnología, ciberseguridad e innovación digital en Ecuador." />
                    <meta property="og:url" content="https://www.cuysoft.com/blog-grid" />
                </Helmet>
                {/* Helmet end */}

                {/* ThemeMenuThree */}
                <ThemeMenuThree />
                {/* ThemeMenuThree */}

                {/* PageTitle */}
                <PageTitle title="Blog Cuadrícula" />
                {/* PageTitle */}

                {/*blog-grid-area start*/}
                <section className="blog-grid-area pt-150 pb-105 pt-lg-60 pb-lg-15">
                    <div className="container">
                        {/* BlogStyleTwo start */}
                        <BlogStyleTwo />
                        {/* BlogStyleTwo start */}
                        <div className="row">
                            <div
                                className="col-lg-12 d-flex align-items-center justify-content-center mb-45">
                                <Link className="theme_btn" to="/blog-details-v1">Cargar Más</Link>
                            </div>
                        </div>
                    </div>
                </section>
                {/*blog-grid-area end*/}

                {/*cuysoft-newsletter start*/}
                <NewsletterTwo />
                {/*cuysoft-newsletter end*/}

                {/* FooterThree start */}
                <FooterThree />
                {/* FooterThree end */}

            </div>

        </Fragment>
    )
}

export default BlogGrid